module.exports = __webpack_public_path__ + "static/media/r-small.a8f3fcf2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/planets/r-small.png
// module id = 1864
// module chunks = 0